import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// import { RegistraturaComponent } from '../app/registratura/registratura.component'
import { VerificareAutoComponent } from '../app/ddru/ridicari-auto/verificare-auto/verificare-auto.component'

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./ddru/registratura-online/registratura-online.module').then(m => m.RegistraturaOnlineModule)
    },
    {
        path: 'registratura-online',
        loadChildren: () => import('./ddru/registratura-online/registratura-online.module').then(m => m.RegistraturaOnlineModule)
    },
    {
        path: 'verificare-auto',
        loadChildren: () => import('./ddru/ridicari-auto/verificare-auto/verificare-auto.module').then(m => m.VerificareAutoModule)
    },
    {
        path: 'plati-ridicari-auto',
        loadChildren: () => import('./ddru/ridicari-auto/plati-ridicari-auto/plati-ridicari-auto.module').then(m => m.PlatiRidicariAutoModule)
    },
    {
        path: 'plati-blocari-auto',
        loadChildren: () => import('./ddru/blocari-auto/plati-blocari-auto/plati-blocari-auto.module').then(m => m.PlatiBlocariAutoModule)
    },
    {
        path: 'documente',
        loadChildren: () => import('./ddru/documente/documente.module').then(m => m.DocumenteModule)
    },
    {
        path: 'plati-online',
        loadChildren: () => import('./dmu/plati-online/plati-online.module').then(m => m.PlatiOnlineModule)
    },
    {
        path: 'plata-taxa',
        loadChildren: () => import('./dmu/plata-taxa/plata-taxa.module').then(m => m.PlataTaxaModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        useHash: true
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
